import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { borderRadiusFull } = theme();
    return StyleSheet.create({
        button: {
            borderRadius: borderRadiusFull,
        },
        container: {
            flex: 1,
        },
    });
};
export { style };
